import { useState, useEffect } from 'react';

const STORAGE_KEY = 'workernet-search-history';
const MAX_HISTORY_ITEMS = 10;

/**
 * Hook для управления историей поиска
 */
export function useSearchHistory() {
  const [history, setHistory] = useState<string[]>([]);

  // Загрузка истории из localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        setHistory(Array.isArray(parsed) ? parsed : []);
      }
    } catch (error) {
      console.error('Failed to load search history:', error);
    }
  }, []);

  // Добавление нового запроса в историю
  const addToHistory = (query: string) => {
    const trimmed = query.trim();
    if (!trimmed || trimmed.length < 3) return;

    setHistory((prev) => {
      // Удаляем дубликаты и добавляем в начало
      const filtered = prev.filter((item) => item !== trimmed);
      const newHistory = [trimmed, ...filtered].slice(0, MAX_HISTORY_ITEMS);

      // Сохраняем в localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory));
      } catch (error) {
        console.error('Failed to save search history:', error);
      }

      return newHistory;
    });
  };

  // Очистка истории
  const clearHistory = () => {
    setHistory([]);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear search history:', error);
    }
  };

  return {
    history,
    addToHistory,
    clearHistory,
  };
}

